export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/profile.45426551.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};